// Deutsch.
export default {
    'canvas.title': 'Seiteninhalt',
    'canvas.loading': 'Editor wird geladen…',
    'empty.title': 'Beginnen Sie Ihre Seite',
    'empty.text': 'Ziehen Sie einen Block oder eine fertige Sektion hierher, oder klicken Sie darauf, um sie hinzuzufügen.',
    'empty.sections': 'Sektionen ansehen',
    'empty.blocks': 'Block hinzufügen',

    'panel.insert': 'Hinzufügen',
    'panel.settings': 'Einstellungen',
    'panel.content': 'Inhalt',
    'panel.layout': 'Layout',
    'panel.style': 'Stil',
    'panel.visibility': 'Sichtbarkeit',
    'panel.advanced': 'Erweitert',
    'tab.blocks': 'Blöcke',
    'tab.sections': 'Sektionen',
    'tab.layers': 'Ebenen',
    'category.layout': 'Layout',
    'category.basic': 'Grundlagen',
    'category.media': 'Medien',
    'category.components': 'Komponenten',
    'category.advanced': 'Erweitert',
    'palette.hint': 'In die Seite ziehen oder zum Hinzufügen klicken',
    'palette.none': 'Kein Block entspricht Ihrer Suche.',
    'sections.intro': 'Ziehen Sie eine Sektion in die Seite oder klicken Sie darauf. Alles bleibt bearbeitbar.',
    'layers.empty': 'Die Seite ist leer.',
    'inspector.empty': 'Wählen Sie einen Block der Seite aus, um Inhalt und Stil zu bearbeiten.',
    'inspector.path': 'Position auf der Seite',

    'device.label': 'Vorschaugröße',
    'device.desktop': 'Desktop',
    'device.tablet': 'Tablet',
    'device.mobile': 'Smartphone',

    'action.undo': 'Rückgängig',
    'action.redo': 'Wiederholen',
    'action.guides': 'Umrisse der Blöcke anzeigen',
    'action.preview': 'Vorschau',
    'action.code': 'Code bearbeiten',
    'action.copyCode': 'Code kopieren',
    'action.fullscreen': 'Vollbild',
    'action.selectParent': 'Übergeordneten Block auswählen',
    'action.move': 'Zum Verschieben ziehen',
    'action.moveUp': 'Nach oben',
    'action.moveDown': 'Nach unten',
    'action.duplicate': 'Duplizieren',
    'action.remove': 'Löschen',
    'action.close': 'Schließen',
    'action.apply': 'Übernehmen',
    'action.cancel': 'Abbrechen',
    'action.clear': 'Leeren',
    'action.search': 'Suchen',
    'action.searchBlocks': 'Block suchen…',
    'action.addColumn': 'Spalte hinzufügen',
    'action.equalize': 'Gleiche Breiten',
    'action.addButton': 'Button hinzufügen',
    'action.addItem': 'Eintrag hinzufügen',
    'action.resizeColumns': 'Ziehen, um die Spaltenbreite zu ändern',
    'category.saved': 'Gespeichert',
    'action.saveBlock': 'Als wiederverwendbaren Block speichern',
    'action.save': 'Speichern',
    'action.restore': 'Wiederherstellen',
    'saved.name': 'Name des Blocks',
    'saved.help': 'Der Block mit seinem gesamten Inhalt steht unter Blöcke › Gespeichert bereit, für diese und alle weiteren Seiten.',
    'saved.done': 'Block gespeichert: Sie finden ihn unter Blöcke › Gespeichert.',
    'saved.remove': 'Diesen gespeicherten Block entfernen',
    'notice.draftFound': 'Änderungen vom {date} wurden nicht gespeichert.',
    'error.storage': 'Der Browser konnte diesen Block nicht speichern (Speicher voll oder deaktiviert).',

    'shortcut.undo': 'rückgängig',
    'shortcut.duplicate': 'duplizieren',
    'shortcut.move': 'nach oben oder unten',
    'shortcut.remove': 'löschen',
    'shortcut.parent': 'übergeordneten Block wählen',
    'shortcut.edit': 'Text bearbeiten',

    'block.container': 'Container',
    'block.containerFluid': 'Volle Breite',
    'block.box': 'Box',
    'block.row': 'Zeile',
    'block.col': 'Spalte',
    'block.heading': 'Überschrift',
    'block.text': 'Text',
    'block.quote': 'Zitat',
    'block.list': 'Liste',
    'block.table': 'Tabelle',
    'block.button': 'Button',
    'block.separator': 'Trennlinie',
    'block.spacer': 'Abstand',
    'block.icon': 'Symbol',
    'block.html': 'HTML',
    'block.image': 'Bild',
    'block.video': 'Video',
    'block.embed': 'Eingebettete Seite',
    'block.map': 'Karte',
    'block.card': 'Karte (Artikel)',
    'block.accordion': 'Akkordeon',
    'preset.cols1': '1 Spalte',
    'preset.cols2': '2 Spalten',
    'preset.cols3': '3 Spalten',
    'preset.cols4': '4 Spalten',
    'preset.cols84': '2/3 + 1/3',
    'preset.cols48': '1/3 + 2/3',
    'preset.cols363': '1/4 + 1/2 + 1/4',
    'preset.cols6': '6 Spalten',

    'placeholder.heading': 'Ihre Überschrift',
    'placeholder.text': 'Schreiben Sie hier Ihren Text. Markieren Sie Wörter, um sie fett, kursiv oder als Link zu setzen.',
    'placeholder.quote': 'Ein starkes Zitat, kurz und einprägsam.',
    'placeholder.author': 'Name des Autors',
    'placeholder.item': 'Eintrag',
    'placeholder.column': 'Spalte',
    'placeholder.button': 'Hier klicken',
    'placeholder.readMore': 'Weiterlesen',
    'placeholder.caption': 'Bildunterschrift',
    'placeholder.cardTitle': 'Titel der Karte',
    'placeholder.cardText': 'Eine kurze Beschreibung, die Lust auf mehr macht.',
    'placeholder.question': 'Frage',
    'placeholder.answer': 'Die Antwort, in wenigen klaren Sätzen.',
    'placeholder.html': 'Ihr HTML-Code',
    'placeholder.address': 'Eiffelturm, Paris',

    'field.width': 'Breite',
    'field.tag': 'HTML-Tag',
    'field.gutters': 'Abstand zwischen den Spalten',
    'field.justify': 'Horizontale Ausrichtung',
    'field.alignItems': 'Vertikale Ausrichtung',
    'field.alignSelf': 'Vertikale Ausrichtung in der Zeile',
    'field.columnWidth': 'Breite je Bildschirmgröße',
    'field.level': 'Ebene',
    'field.size': 'Größe',
    'field.thickness': 'Stärke',
    'field.opacity': 'Deckkraft',
    'field.height': 'Höhe',
    'field.icon': 'Symbol',
    'field.filled': 'Gefüllt',
    'field.image': 'Bild',
    'field.alt': 'Alternativtext',
    'field.link': 'Link',
    'field.newTab': 'In neuem Tab öffnen',
    'field.caption': 'Bildunterschrift',
    'field.align': 'Ausrichtung',
    'field.ratio': 'Seitenverhältnis',
    'field.corners': 'Ecken',
    'field.shadow': 'Schatten',
    'field.videoUrl': 'Video',
    'field.controls': 'Bedienelemente anzeigen',
    'field.autoplay': 'Automatisch abspielen (stumm)',
    'field.loop': 'Wiederholen',
    'field.muted': 'Stumm',
    'field.url': 'Adresse (URL)',
    'field.address': 'Adresse',
    'field.zoom': 'Zoom',
    'field.showImage': 'Bild anzeigen',
    'field.titleLevel': 'Ebene des Titels',
    'field.showButton': 'Button anzeigen',
    'field.firstOpen': 'Erster Eintrag geöffnet',
    'field.items': 'Einträge',
    'field.question': 'Frage',
    'field.text': 'Text',
    'field.style': 'Stil',
    'field.code': 'HTML-Code',
    'field.textAlign': 'Textausrichtung',
    'field.spacing': 'Abstände',
    'field.margin': 'Außenabstand',
    'field.padding': 'Innenabstand',
    'field.background': 'Hintergrund',
    'field.backgroundImage': 'Hintergrundbild',
    'field.textColor': 'Textfarbe',
    'field.border': 'Rahmen',
    'field.showOn': 'Anzeigen auf',
    'field.id': 'Anker (ID)',
    'field.classes': 'CSS-Klassen',
    'field.inlineStyle': 'Inline-Stil',
    'side.t': 'oben',
    'side.b': 'unten',
    'side.s': 'links',
    'side.e': 'rechts',

    'help.alt': 'Beschreibt das Bild für Menschen, die es nicht sehen, und für Suchmaschinen.',
    'help.video': 'Ein YouTube- oder Vimeo-Link oder die Adresse einer MP4-Datei.',
    'help.embed': 'Die Adresse einer Seite, die eingebettet werden darf (ein Formular, ein Kalender…).',
    'help.columnWidth': 'Smartphone zuerst: Eine leere Größe übernimmt die des kleineren Bildschirms (grau angezeigt).',
    'help.visibility': 'Entfernen Sie den Haken bei einer Größe, um den Block auf diesen Bildschirmen auszublenden.',
    'help.id': 'Damit kann ein Link auf diesen Block zeigen: #anker.',
    'help.classes': 'Klassen Ihres Themes oder von Bootstrap, durch Leerzeichen getrennt.',
    'help.accordion': 'Klicken Sie in der Seite auf eine Frage oder Antwort, um ihren Text zu bearbeiten.',
    'help.html': 'Skripte und Event-Attribute werden aus Sicherheitsgründen entfernt.',

    'option.default': 'Standard',
    'option.none': 'Keine',
    'option.auto': 'Auto',
    'option.fill': 'Ausfüllen',
    'option.inherit': 'Erben',
    'option.custom': 'Eigene Farbe',
    'option.boxed': 'Zentriert',
    'option.fullWidth': 'Volle Breite',
    'option.start': 'Links',
    'option.center': 'Mitte',
    'option.end': 'Rechts',
    'option.between': 'Verteilt',
    'option.top': 'Oben',
    'option.middle': 'Mitte',
    'option.bottom': 'Unten',
    'option.wrapLeft': 'Links, Text umfließt',
    'option.wrapRight': 'Rechts, Text umfließt',
    'option.original': 'Original',
    'option.square': 'Eckig',
    'option.rounded': 'Abgerundet',
    'option.pill': 'Pille',
    'option.circle': 'Kreis',
    'option.small': 'Klein',
    'option.medium': 'Mittel',
    'option.large': 'Groß',
    'button.primary': 'Primär',
    'button.outline-primary': 'Primär, Umriss',
    'button.secondary': 'Sekundär',
    'button.outline-secondary': 'Sekundär, Umriss',
    'button.success': 'Erfolg',
    'button.outline-success': 'Erfolg, Umriss',
    'button.danger': 'Gefahr',
    'button.outline-danger': 'Gefahr, Umriss',
    'button.warning': 'Warnung',
    'button.outline-warning': 'Warnung, Umriss',
    'button.info': 'Info',
    'button.outline-info': 'Info, Umriss',
    'button.light': 'Hell',
    'button.outline-light': 'Hell, Umriss',
    'button.dark': 'Dunkel',
    'button.outline-dark': 'Dunkel, Umriss',
    'button.link': 'Link',

    'rte.toolbar': 'Textformatierung',
    'rte.format': 'Absatzformat',
    'rte.paragraph': 'Absatz',
    'rte.lead': 'Einleitung',
    'rte.small': 'Kleiner Text',
    'rte.table': 'Tabelle…',
    'rte.rowAbove': 'Zeile darüber einfügen',
    'rte.rowBelow': 'Zeile darunter einfügen',
    'rte.colLeft': 'Spalte links einfügen',
    'rte.colRight': 'Spalte rechts einfügen',
    'rte.deleteRow': 'Zeile löschen',
    'rte.deleteCol': 'Spalte löschen',
    'rte.deleteTable': 'Tabelle löschen',
    'rte.heading': 'Überschrift {n}',
    'rte.quote': 'Zitat',
    'rte.code': 'Code',
    'rte.bold': 'Fett (Strg+B)',
    'rte.italic': 'Kursiv (Strg+I)',
    'rte.underline': 'Unterstrichen (Strg+U)',
    'rte.strike': 'Durchgestrichen',
    'rte.link': 'Link (Strg+K)',
    'rte.unlink': 'Link entfernen',
    'rte.bulletList': 'Aufzählung',
    'rte.numberedList': 'Nummerierte Liste',
    'rte.alignLeft': 'Linksbündig',
    'rte.alignCenter': 'Zentrieren',
    'rte.alignRight': 'Rechtsbündig',
    'rte.justify': 'Blocksatz',
    'rte.clear': 'Formatierung entfernen',

    'media.upload': 'Hochladen',
    'media.library': 'Auswählen',
    'media.urlOnly': 'Fügen Sie die Adresse der Datei ein. Dateien vom Computer zu senden erfordert eine Upload-Adresse (Option uploadUrl).',
    'media.embedded': 'In der Seite gespeichertes Bild',

    'code.title': 'HTML-Code der Seite',
    'code.help': 'Bearbeiten Sie den Code und übernehmen Sie ihn: PageFlow erkennt seine Blöcke wieder. Skripte werden entfernt.',

    'notice.copied': 'Code in die Zwischenablage kopiert',
    'notice.noGrid': 'Die Stile der Website wurden im Editor nicht geladen: Vorerst wird ein einfaches Raster verwendet. Prüfen Sie die Option canvasStyles.',
    'notice.codeApplied': 'Code übernommen',
    'notice.cannotInsert': 'Dieser Block kann hier nicht stehen. Wählen Sie zuerst eine Spalte oder einen Container aus.',
    'error.copy': 'Der Code konnte nicht kopiert werden. Markieren Sie ihn in der Code-Ansicht.',
    'error.fileType': 'Dieser Dateityp wird hier nicht akzeptiert.',
    'error.fileSize': 'Diese Datei ist zu groß (höchstens {size} MB).',
    'error.upload': 'Die Datei konnte nicht hochgeladen werden.',
    'error.noUpload': 'Es ist keine Upload-Adresse eingestellt: Dateien des Computers können nicht gesendet werden. Fügen Sie stattdessen die Adresse der Datei ein (Entwickler: Option uploadUrl, PHP-Handler enthalten).',

    'sec.heroSplit': 'Hero mit Bild',
    'sec.heroSplitDesc': 'Titel, Text und Buttons neben einem Foto.',
    'sec.heroCenter': 'Zentrierter Hero',
    'sec.heroCenterDesc': 'Eine große, zentrierte Botschaft auf hellem Band.',
    'sec.features': 'Stärken',
    'sec.featuresDesc': 'Drei Stärken mit Symbolen.',
    'sec.imageText': 'Bild und Text',
    'sec.imageTextDesc': 'Ein Foto neben einem Text und einer Liste.',
    'sec.cta': 'Handlungsaufforderung',
    'sec.ctaDesc': 'Ein farbiges Band mit einem klaren Button.',
    'sec.cards': 'Karten',
    'sec.cardsDesc': 'Drei Artikel, Produkte oder Leistungen.',
    'sec.testimonials': 'Kundenstimmen',
    'sec.testimonialsDesc': 'Was Ihre Kunden über Sie sagen.',
    'sec.pricing': 'Preise',
    'sec.pricingDesc': 'Drei Tarife nebeneinander.',
    'sec.faq': 'FAQ',
    'sec.faqDesc': 'Fragen und Antworten, die sich per Klick öffnen.',
    'sec.stats': 'Kennzahlen',
    'sec.statsDesc': 'Vier Zahlen, die Vertrauen schaffen.',
    'sec.team': 'Team',
    'sec.teamDesc': 'Porträts mit Namen und Funktionen.',
    'sec.contact': 'Kontakt',
    'sec.contactDesc': 'Adresse, Telefon und E-Mail neben einer Karte.',
    'sec.gallery': 'Galerie',
    'sec.galleryDesc': 'Sechs Fotos im Raster.',
    'sec.heroTitle': 'Schöne Seiten in wenigen Minuten',
    'sec.heroText': 'Ziehen, ablegen, schreiben: Ihre Seite ist fertig, mobil optimiert und sauber, ohne eine einzige Zeile Code.',
    'sec.getStarted': 'Jetzt starten',
    'sec.learnMore': 'Mehr erfahren',
    'sec.contactUs': 'Kontakt aufnehmen',
    'sec.imageAlt': 'Foto',
    'sec.centerTitle': 'Alles, was Sie brauchen, nichts zu viel',
    'sec.centerText': 'Ein einfaches Versprechen, das Ihren Besuchern sagt, dass sie richtig sind.',
    'sec.featuresTitle': 'Warum Kunden uns wählen',
    'sec.featuresText': 'Drei gute Gründe, kurz erklärt.',
    'sec.feature1': 'Schnell',
    'sec.feature2': 'Zuverlässig',
    'sec.feature3': 'Für Smartphones gemacht',
    'sec.featureText': 'Beschreiben Sie diese Stärke in ein oder zwei Sätzen, die Ihre Besucher ansprechen.',
    'sec.imageTextTitle': 'Erzählen Sie Ihre Geschichte',
    'sec.imageTextText': 'Erklären Sie, was Sie tun und wie Sie helfen, mit den Worten Ihrer Kunden.',
    'sec.point1': 'Ein erster Vorteil',
    'sec.point2': 'Ein zweiter Vorteil',
    'sec.point3': 'Ein dritter Vorteil',
    'sec.ctaTitle': 'Bereit loszulegen?',
    'sec.ctaText': 'Schließen Sie sich allen an, die uns bereits vertrauen. Es dauert nur eine Minute.',
    'sec.cardsTitle': 'Neuigkeiten',
    'sec.cardTitle': 'Ein Kartentitel',
    'sec.cardText': 'Eine kurze Zusammenfassung, die Lust aufs Weiterlesen macht.',
    'sec.readMore': 'Weiterlesen',
    'sec.testimonialsTitle': 'Das sagen unsere Kunden',
    'sec.quote1': 'Einfach, schnell und schön. Wir haben unsere ganze Website an einem Wochenende neu gebaut.',
    'sec.quote2': 'Der Support hat innerhalb einer Stunde geantwortet. Ohne Zögern zu empfehlen.',
    'sec.quote3': 'Seit den neuen Seiten bleiben unsere Besucher länger und melden sich öfter.',
    'sec.name1': 'Emma Lawson',
    'sec.name2': 'Lukas Martin',
    'sec.name3': 'Sofia Rossi',
    'sec.role1': 'Gründerin, Studio Nord',
    'sec.role2': 'Geschäftsführer, Blauer Hafen',
    'sec.role3': 'Leiterin, Atelier Verde',
    'sec.pricingTitle': 'Einfache Preise',
    'sec.pricingText': 'Keine versteckten Kosten. Jederzeit wechseln oder kündigen.',
    'sec.plan1': 'Starter',
    'sec.plan2': 'Professional',
    'sec.plan3': 'Business',
    'sec.month': 'Monat',
    'sec.benefit1': 'Ein erster Vorteil',
    'sec.benefit2': 'Ein zweiter Vorteil',
    'sec.benefit3': 'Ein dritter Vorteil',
    'sec.choose': 'Diesen Tarif wählen',
    'sec.faqTitle': 'Häufige Fragen',
    'sec.question1': 'Wie fange ich an?',
    'sec.answer1': 'Wählen Sie einen Tarif, legen Sie Ihr Konto an und folgen Sie der Anleitung: Es dauert nur wenige Minuten.',
    'sec.question2': 'Kann ich den Tarif später wechseln?',
    'sec.answer2': 'Ja, jederzeit. Die Differenz wird für Sie berechnet.',
    'sec.question3': 'Bieten Sie Unterstützung an?',
    'sec.answer3': 'Unser Team antwortet an jedem Werktag per E-Mail.',
    'sec.question4': 'Sind meine Daten sicher?',
    'sec.answer4': 'Ihre Daten werden sicher gespeichert und niemals weitergegeben.',
    'sec.stat1': 'zufriedene Kunden',
    'sec.stat2': 'Zufriedenheit',
    'sec.stat3': 'Support',
    'sec.stat4': 'Länder',
    'sec.teamTitle': 'Das Team',
    'sec.member': 'Teammitglied',
    'sec.jobTitle': 'Funktion',
    'sec.contactTitle': 'Kontakt',
    'sec.contactText': 'Wir freuen uns auf Ihre Nachricht. Schreiben Sie uns oder besuchen Sie uns.',
    'sec.addressLabel': 'Adresse',
    'sec.address': '5 Avenue Anatole France, 75007 Paris',
    'sec.phoneLabel': 'Telefon',
    'sec.emailLabel': 'E-Mail',
    'sec.galleryTitle': 'Galerie',
};
